import { type Enum } from '@webapp/infrastructure/types/Enum'

export const MileageRatePresetUnits = {
  MILES: 'miles',
  KILOMETERS: 'kilometers',
} as const

export type MileageRatePresetUnitEnum = Enum<typeof MileageRatePresetUnits>
